<script setup lang="ts"></script>

<template>
  <ul data-test="stash-menu" class="stash-menu m-0 list-none rounded bg-white p-1.5" role="menu">
    <slot></slot>
  </ul>
</template>
